import { entries } from "lodash";
import * as fieldTypes from "./fieldTypes";
import {
  NewPatientStatesField,
  MaxPanelField,
  PracticeTeamField,
  SharePanelField,
  StatesField,
  NewPatientsDailyLimitField,
  AcceptNewPatientsField
} from "../fields";
import { MENTAL_HEALTH, VPC } from "./specialties";

const FORM_FIELDS = {
  [fieldTypes.PRACTICE_TEAM]: PracticeTeamField,
  [fieldTypes.STATES]: StatesField,
  [fieldTypes.MAX_PANEL]: MaxPanelField,
  [fieldTypes.SHARE_PANEL]: SharePanelField,
  [fieldTypes.ACCEPT_NEW_PATIENTS]: AcceptNewPatientsField,
  [fieldTypes.NEW_PATIENT_STATES]: NewPatientStatesField,
  [fieldTypes.NEW_PATIENTS_DAILY_LIMIT]: NewPatientsDailyLimitField,
};

export const FIELD_TYPES_BY_SPECIALTY = {
  [MENTAL_HEALTH]: [
    fieldTypes.ACCEPT_NEW_PATIENTS,
    fieldTypes.NEW_PATIENT_STATES,
    fieldTypes.MAX_PANEL,
    fieldTypes.NEW_PATIENTS_DAILY_LIMIT,
  ],
  [VPC]: [
    fieldTypes.PRACTICE_TEAM,
    fieldTypes.STATES,
    fieldTypes.MAX_PANEL,
    fieldTypes.SHARE_PANEL,
  ]
};

export const FORM_FIELDS_BY_SPECIALTY = entries(FIELD_TYPES_BY_SPECIALTY).reduce((acc, [specialty, fieldTypes]) => {
    acc[specialty] = fieldTypes.map(fieldType => FORM_FIELDS[fieldType]);
    return acc;
  }, {});

export const CREATE_FORM_FIELDS = [
  fieldTypes.PRACTICE_TEAM,
  fieldTypes.MAX_PANEL,
  fieldTypes.ACCEPT_NEW_PATIENTS,
  fieldTypes.STATES,
  fieldTypes.SHARE_PANEL,
  fieldTypes.NEW_PATIENTS_DAILY_LIMIT,
  fieldTypes.NEW_PATIENT_STATES,
];

export const UPDATE_FORM_FIELDS = [
  fieldTypes.MAX_PANEL,
  fieldTypes.ACCEPT_NEW_PATIENTS,
  fieldTypes.STATES,
  fieldTypes.SHARE_PANEL,
  fieldTypes.NEW_PATIENTS_DAILY_LIMIT,
  fieldTypes.NEW_PATIENT_STATES,
];
